import './PrivacyTermsComponentSkeleton.scss';

const PrivacyTermsComponentSkeleton = () => {

    return (
        <div className="privacy-terms__wrapper__skeleton">
            {[...Array(7)].map((_, index) => (
                <div key={index} className='privacy-terms__rules__item__skeleton'>
                    <div className='privacy-terms__rules__item__title__wrapper__skeleton'>
                        <div className="privacy-terms__rules__item__title__skeleton"></div>
                    </div>
                    <div className='privacy-terms__rules__item__content__wrapper__skeleton'>
                        {[...Array(6)].map((_, index) => (
                            <div key={index} className='privacy-terms__rules__item__content__skeleton'></div>
                        ))}
                        <div className='privacy-terms__rules__item__content__skeleton--primary'></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PrivacyTermsComponentSkeleton;